import { ProductInspectionSampleDto } from "libs/shared-models/production-management/src/lib/product-inspection/product-inspection-samples.dto";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ProductInspectionSamples } from "./product-inspection-samples.entity";

@Entity('product_inspection')

export class ProductInspection {
    @PrimaryGeneratedColumn("increment", { name: 'inspection_id' })
    inspectionId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'sale_order_id'
    })
    saleOrderId: number;

    @Column({
        type: 'int',
        nullable: false,
        
        name: 'sale_order_item_id'
    })
    saleOrderItemId: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "lot_number"
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "section"
    })
    section: string;

    @Column({
        nullable: true,
        name: 'inspection_date',
    })
    date: Date;
   

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => ProductInspectionSamples, samples => samples.inspectionInfo, { cascade: true })
    samplesInfo: ProductInspectionSamples[];
}